module.exports = __webpack_public_path__ + "img/home-img-03.f6f4c5ad.png";